var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-2",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"6"}},[_c('avatar',{attrs:{"initialWidth":_vm.avatarWidth}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('menuMatrix')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }